import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Node, NodeEntry } from '@alfresco/js-api';
import { TranslationService } from '@alfresco/adf-core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DocuServeConfigurationService } from '../../services/docuserve-configuration.service';
import { ContentNodeSelectorComponent, ContentNodeSelectorComponentData, NodeAction } from '@alfresco/adf-content-services';
import { Observable, Subject } from 'rxjs';


@Component({
  selector: 'jobdocuments-select-category-dialog',
  templateUrl: './select-category-dialog.component.html',
  styleUrls: ['./select-category-dialog.component.scss'],

})
export class SelectCategoryDialogComponent  implements OnInit{

  title: "Select Category";
  folderId: "";
  submitButtonLabel: string = "APP.JOB-DOCUMENTS.DIALOGS.BUTTONS.OK";

  form!: FormGroup;
  folder!: NodeEntry;
  documentTypes: any = [""];
  targetFolderToolTip: string = "";
  public appConfigData: any;

   /** Emitted when the select folder give error
   */
    @Output()
    error: EventEmitter<any> = new EventEmitter<any>();

    /** Emitted when submit is successful
     */
    @Output()
    success: EventEmitter<any> = new EventEmitter<Node>();


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<SelectCategoryDialogComponent>,
    private categorySelectorDialog: MatDialog,
    private translationService: TranslationService,
    private configService: DocuServeConfigurationService,
    private formBuilder: FormBuilder) {

    this.title = data.title;
    this.folderId = data.folderId;
    if(data.submitButtonLabel){
     this.submitButtonLabel = data.submitButtonLabel;
    }

  }

  ngOnInit(): void {

    this.configService.getAppConfig().subscribe(data => {
      this.appConfigData = data;
    });

    this.form = this.formBuilder.group({
      targetFolder: ["", Validators.required],
      targetFolderNode:[null],
      documentType: ["", Validators.required],

    });
  }

  submit() {
    const { form, dialog } = this;

    if (!form.valid) {
      return;
    }

    this.success.emit(form.value);
    dialog.close(form.value);

  }

  handleError(error: any): any {
    let errorMessage = 'CORE.MESSAGES.ERRORS.GENERIC';

    try {
      const {
        error: { statusCode }
      } = JSON.parse(error.message);

      if (statusCode === 409) {
        errorMessage = 'CORE.MESSAGES.ERRORS.EXISTENT_FOLDER';
      }
    } catch (err) {
      /* Do nothing, keep the original message */
    }

    this.error.emit(this.translationService.instant(errorMessage));

    return error;
  }

  openCategoryFolderSelectorDialog(){

    this.documentTypes = [""];
    this.form.reset();

    this.openSelectCategoryFolderDialog(this.folderId)
            .subscribe((selections: Node[]) => {

                // place your action here on operation success!
                console.log("selected folder", selections);
                // get the values from the first selected item
                let firstNode: Node = selections[0];
                if(firstNode){

                  this.form.controls['targetFolder'].setValue(firstNode.name);

                  let pathName = firstNode.path?.name ?? '';
                  pathName = pathName.substring(pathName.indexOf("documentLibrary") + 15) + "/" + firstNode.name;
                  this.targetFolderToolTip = pathName;
                  this.form.controls['targetFolderNode'].setValue(firstNode);


                  let path = firstNode.path;
                  if(path && path.elements){
                    // update the list of values available for the document type list control
                    let functionKey: string = path.elements[path.elements.length - 1].name ?? '';
                    let categoryKey: string = selections[0].name;


                    //console.log("categoryKey", categoryKey);

                    //this.documentTypes = data.metadata[functionKey]['ajg:documentType'];
                    this.documentTypes = this.appConfigData.metadata['ch:documentType'][functionKey][categoryKey];
                  }
                  //console.log("documentType List", this.documentTypes);
                  }
              });
  }

   /**
     * Opens a dialog to choose a file to upload.
     *
     * @param action Name of the action to show in the title
     * @param folderId browse start location

     * @returns Information about the chosen file(s)
     */
    openSelectCategoryFolderDialog(folderId: string): Observable<Node[]> {
      const select = new Subject<Node[]>();

      console.log("Select content node");
      const data: ContentNodeSelectorComponentData = {
          title: this.translationService.instant('APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.SELECT-CATEGORY-FOLDER'),

          actionName: NodeAction.NEXT,
          selectionMode: 'single',
          currentFolderId: folderId,
          isSelectionValid: (entry: Node) => entry.nodeType === "ch:categoryFolder",
          select,
          showFilesInResult: false,
          showDropdownSiteList: false,
          where: '(isFolder=true)',
      };

      const dialogRef = this.openContentNodeDialog(data, 'adf-content-node-selector-dialog', '630px');
        // dialogRef.afterOpened().subscribe((data) => {


        // });
      dialogRef.afterClosed().subscribe({ next: () => select.complete() });

      return select;
  }

  private openContentNodeDialog(
    data: ContentNodeSelectorComponentData,
    panelClass: string,
    width: string
): MatDialogRef<ContentNodeSelectorComponent> {
    return this.categorySelectorDialog.open(ContentNodeSelectorComponent, {
        data,
        panelClass,
        width,
        disableClose: true
    });
}



}
